import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import AuthModal from '../auth/AuthModal';
import LogoutModal from '../auth/LogoutModal';
import MasterData from '../../utility/masterData'
import { selectLanguage } from '../../redux/slices/UserDetailSlice';
import { activeLanguage } from '../../redux/slices/changeLanguageSlice';
import HEADERLOGO from '../../assets/images/BYKUSH_Logo.png';

const Header = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [authType, setAuthType] = useState("login");
    const [lang, setLang] = useState("en");
    
    // Theme state
    const [theme, setTheme] = useState(localStorage.getItem('bykush_theme') || 'dark');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('bykush_theme', theme);
    }, [theme]);

    const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

    const userDetailState = useSelector((state) => state.userDetailState);

    const openAuthModal = () => {
        setShowAuthModal(!showAuthModal);
        setAuthType("login");
    }

    const handleModeChangeAuthModal = () => setShowAuthModal(!showAuthModal)
    const handleChangeLogoutModal = () => setShowLogoutModal(!showLogoutModal)

    const handleChangeAuthType = () => {
        setAuthType(authType === "login" ? "register" : "login");
    }

    const openLogoutModal = () => setShowLogoutModal(!showLogoutModal)

    const chooseLanguage = (e) => {
        setLang(e.target.value);
        dispatch(selectLanguage(e.target.value));
        dispatch(activeLanguage({ language_code: e.target.value }));
    }

    const user = userDetailState?.user_details;
    const balance = user?.available_balance != undefined
        ? Number(user.available_balance.toFixed(2))?.toLocaleString()
        : '0.00';

    const getCurrencyIcon = (currency) => {
        const c = String(currency || '').toLowerCase();
        switch (c) {
            case 'usd': return 'fa-solid fa-dollar-sign';
            case 'try': return 'fa-solid fa-turkish-lira-sign';
            case 'eur': return 'fa-solid fa-euro-sign';
            case 'inr': return 'fa-solid fa-rupee-sign';
            case 'idr':
            case 'idr2': return 'fa-solid fa-rupiah-sign';
            case 'cny': return 'fa-solid fa-yen-sign';
            case 'vnd': return 'fa-solid fa-dong-sign';
            case 'thb': return 'fa-solid fa-baht-sign';
            case 'mkd': return 'fa-solid fa-money-bill';
            default: return 'fa-solid fa-coins';
        }
    };

    return (
        <div className="head_main mb-0">
            <div className="container">
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '8px 0',
                    flexWrap: 'nowrap',
                    gap: 8,
                    overflow: 'hidden'
                }}>
                    {/* Left: Logo (mobile only) + User Info */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, flex: 1, overflow: 'hidden' }}>
                        <img 
                            src={HEADERLOGO} 
                            alt="ByKush" 
                            className="header-brand-logo mobile-only"
                            style={{ 
                                width: '28px', 
                                height: 'auto', 
                                filter: 'drop-shadow(0 0 6px rgba(46,201,176,0.3))',
                                flexShrink: 0
                            }} 
                        />
                        {user ? (
                            <>
                                <span className="head-user" style={{ color: 'var(--text-primary)', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {user.username?.toUpperCase()}
                                </span>
                                <span className="head-balance" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                                    <i className={getCurrencyIcon(user.currency_code)} />
                                    &nbsp;{balance} {user.currency_code}
                                </span>
                            </>
                        ) : (
                            <span style={{ color: 'var(--text-secondary)', fontSize: 13 }}>ByKush</span>
                        )}
                    </div>

                    {/* Right: Theme Toggle, Language, Logout */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                        <button 
                            onClick={toggleTheme} 
                            title={`Switch to ${theme === 'dark' ? 'Light' : 'Dark'} Theme`}
                            style={{ 
                                background: 'transparent', 
                                border: '1px solid rgba(46,201,176,0.3)', 
                                color: 'var(--text-secondary)', 
                                cursor: 'pointer', 
                                fontSize: 14, 
                                padding: '5px 7px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease',
                                lineHeight: 1,
                                flexShrink: 0
                            }}
                            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(46,201,176,0.1)'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                            onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.transform = 'scale(1)'; }}
                        >
                            {theme === 'dark' ? '☀️' : '🌙'}
                        </button>

                        {user && (
                            <select onChange={chooseLanguage} value={lang} className='curency_select desktop-only' style={{ fontSize: 12, padding: '4px 6px' }}>
                                {MasterData.language.map((items, key) => (
                                    <option key={key} value={items.value}>{items.label}</option>
                                ))}
                            </select>
                        )}

                        {user ? (
                            <>
                                {/* Desktop: Full Logout button */}
                                <a onClick={openLogoutModal} className="any-button desktop-only" style={{ cursor: 'pointer' }}>
                                    <FormattedMessage id="LOGOUT" />
                                </a>
                                {/* Mobile: Logout icon */}
                                <button 
                                    onClick={openLogoutModal} 
                                    className="mobile-only"
                                    title={intl.formatMessage({ id: 'LOGOUT' })}
                                    style={{ 
                                        background: 'transparent', 
                                        border: '1px solid rgba(255,77,79,0.3)', 
                                        color: '#ff4d4f', 
                                        cursor: 'pointer', 
                                        fontSize: 14, 
                                        padding: '5px 7px', 
                                        borderRadius: '8px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease',
                                        lineHeight: 1
                                    }}
                                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,77,79,0.1)'; }}
                                    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                                >
                                    <i className="fa fa-power-off" />
                                </button>
                            </>
                        ) : (
                            <a onClick={openAuthModal} className="any-button" style={{ cursor: 'pointer', fontSize: 12, padding: '6px 14px' }}>
                                <FormattedMessage id="LOGIN" />
                            </a>
                        )}
                    </div>
                </div>
            </div>

            <AuthModal authType={authType} handleChangeAuthType={handleChangeAuthType} showAuthModal={showAuthModal} handleModeChangeAuthModal={handleModeChangeAuthModal} />
            <LogoutModal showLogoutModal={showLogoutModal} handleChangeLogoutModal={handleChangeLogoutModal} />
        </div>
    )
}

export default Header
